var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 57,
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6215 31.6744C37.9264 31.6744 39.0891 31.9587 40.1097 32.5272C41.1469 33.0957 41.9583 33.8982 42.5439 34.9349C43.1294 35.9716 43.4222 37.1671 43.4222 38.5215C43.4222 39.8758 43.1294 41.0797 42.5439 42.1331C41.9583 43.1698 41.1469 43.9724 40.1097 44.5409C39.0891 45.1094 37.9264 45.3936 36.6215 45.3936C35.7013 45.3936 34.8565 45.2348 34.0869 44.9171C33.334 44.5994 32.6983 44.1229 32.1797 43.4875V45.2181H29.1934V26.7994V25.0405L32.3302 28.1753V28.5841V33.4551C32.8656 32.8699 33.493 32.4268 34.2124 32.1259C34.9485 31.8249 35.7515 31.6744 36.6215 31.6744ZM36.2701 42.71C37.4245 42.71 38.3698 42.3254 39.1059 41.5563C39.8587 40.7871 40.2352 39.7755 40.2352 38.5215C40.2352 37.2674 39.8587 36.2558 39.1059 35.4867C38.3698 34.7175 37.4245 34.333 36.2701 34.333C35.5173 34.333 34.8397 34.5085 34.2375 34.8597C33.6352 35.1941 33.1584 35.679 32.807 36.3144C32.4557 36.9497 32.28 37.6854 32.28 38.5215C32.28 39.3575 32.4557 40.0932 32.807 40.7286C33.1584 41.364 33.6352 41.8572 34.2375 42.2084C34.8397 42.5428 35.5173 42.71 36.2701 42.71Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_130_13843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1046 13.3936L36.6296 24.9247L35.023 26.5305L25.1046 16.6069L15.5186 26.1979V42.9403H26.4293V45.2118H13.2471V25.2573L25.1046 13.3936Z",
    fill: "#FFE500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_130_13843",
    x: 0.221408,
    y: 0.367893,
    width: 47.5733,
    height: 56.0089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.930404,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_130_13843"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.930404,
    dy: -0.930404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.58243
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.898039 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_130_13843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_130_13843",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOpen);
export default __webpack_public_path__ + "static/media/logoOpen.86ddfc753bec451157cee77e8750d4c0.svg";
export { ForwardRef as ReactComponent };